export const styles = {
    header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 20],
    },
    subheader: {
        fontSize: 14,
        bold: true,
        margin: [0, 10, 0, 10]
    },
    anotherStyle: {
        italics: true,
        alignment: 'right'
    }
}